module.exports = __webpack_public_path__ + "static/media/SwaggerUI.ba7e65f8.gif";